import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    paddingLeft: 24,
    paddingBottom: 16,
    width: 'calc(100% - 48px)'
  },

  messageContainer: {
    display: 'flex',
    fontSize: theme.size.base
  },

  message: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: ({ hasUnreadMessages }) =>
      hasUnreadMessages ? theme.bold.bold : theme.bold.base
  },

  messageSingleLine: {
    lineClamp: 1
  },

  count: {
    flex: '1',
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: '0.5rem'
  }
}))

export default useStyles
